import React, { useEffect } from 'react';
import './staffAugmentation.scss';
import ButtonComponent from '../../Components/Button/button';
import AddIcon from '@mui/icons-material/Add';
import { STAFF_AUGMENTATION } from '../../Constants/strings';
import useStaffAugmentation from './useStaffAugmentation';
import DataGridComponent from '../../Components/DataGrid/dataGrid';
import AddRequirementDialog from './AddEditStaffAugmentation/addEditStaffAugmentation';
import DeleteStaffAugmentationDialog from './deleteStaffAugmentationDialog';
import SimpleSnackbar from '../../Components/Snackbar/snackbar';
import {
  getClientNames,
  filterStaffAugListData,
} from './staffAugmentationUtils';
import StaffAugmentationFilter from './staffAugmentationFilter';
import ArrowDropDown from '../../Assets/images/svg/drop-down-arrow.svg';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import excelIcon from '../../Assets/images/svg/excel.svg';
import excelhoverIcon from '../../Assets/images/svg/excel_hover.svg';
import JobDescriptionView from './jobDescriptionView';
import PuzzleLoader from '../../Assets/images/svg/loading puzzle.gif';

const StaffAugmentationRequirement = () => {
  const {
    rows,
    isEdit,
    isCopy,
    currentPage,
    statusOptions,
    projectOptions,
    employeeNameOptions,
    employeeIdOptions,
    staffAugFilterValues,
    listStaffAugData,
    anchorEl,
    isExcelHovered,
    jobDescView,
    jobDescFileUrl,
    isLoading,
    setRows,
    addRequirementOpen,
    editStaffData,
    setCurrentPage,
    checkMobileView,
    checkAccess,
    setProjectOptions,
    setListStaffAugData,
    setIsEdit,
    setIsCopy,
    fixedColumns,
    sortFilterColumns,
    openSnackbar,
    severity,
    snackbarMessage,
    deleteStaffAugmentationDialog,
    setDeleteStaffAugmentationDialog,
    handleDeleteStaffAugmentation,
    handleStaffAugFilterValues,
    getStaffAugStatusData,
    getEmployeeNameData,
    getEmployeeIdData,
    getStaffAugReqData,
    setAddRequirementOpen,
    setEditStaffData,
    setIsExcelHovered,
    handleCloseMenu,
    handleDownloadClick,
    handleCloseJobDescView,
    handleDownloadExcel,
  } = useStaffAugmentation();

  useEffect(() => {
    checkMobileView();
    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, []);

  useEffect(() => {
    getStaffAugStatusData();
    getEmployeeNameData();
    getEmployeeIdData();
    getStaffAugReqData();
  }, []);

  const handleAddRequirementSubmitClick = () => {
    setAddRequirementOpen(true);
  };

  const handleAddRequirementClose = () => {
    setAddRequirementOpen(false);
    setEditStaffData({});
  };

  useEffect(() => {
    const data = getClientNames(rows);
    setProjectOptions(data);
  }, [rows]);

  useEffect(() => {
    // When employee filters change, fetch data from backend
    getStaffAugReqData();
  }, [staffAugFilterValues.employeeName, staffAugFilterValues.employeeId]);

  useEffect(() => {
    // Apply client-side filtering for project and status
    const filteredData = filterStaffAugListData(rows, staffAugFilterValues);
    setListStaffAugData(filteredData);
  }, [rows, staffAugFilterValues.project, staffAugFilterValues.status]);

  return (
    <div className="staff-augmentation-outer-layer">
      <div className="staff-augmentation">
        <div className="staff-augmentation-title">
          {STAFF_AUGMENTATION.TITLE_TEXT}
        </div>
        <div className="staff-augmentation-add-button">
          <StaffAugmentationFilter
            projectOptions={projectOptions}
            statusOptions={statusOptions}
            employeeNameOptions={employeeNameOptions}
            employeeIdOptions={employeeIdOptions}
            staffAugFilterValues={staffAugFilterValues}
            handletFilterValues={handleStaffAugFilterValues}
          />
          <div className="staff-augmentation-add-download-cont">
            <div>
              <ButtonComponent
                label={STAFF_AUGMENTATION.DOWNLOAD}
                variant="text"
                onClick={handleDownloadClick}
                endIcon={<img src={ArrowDropDown} alt="Dropdown Arrow" />}
                btnCss="download-skill-btn"
              ></ButtonComponent>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
              >
                <MenuItem
                  onClick={() => handleDownloadExcel()}
                  className="downloadskill-dropdown"
                  onMouseEnter={() => setIsExcelHovered(true)}
                  onMouseLeave={() => setIsExcelHovered(false)}
                >
                  <img
                    src={isExcelHovered ? excelhoverIcon : excelIcon}
                    style={{ marginRight: 8 }}
                    alt="excel Icon"
                  />{' '}
                  Download as Excel
                </MenuItem>
              </Menu>
            </div>

            <ButtonComponent
              disabled={!checkAccess('create')}
              id="add-staff-aug-status-btn"
              label={STAFF_AUGMENTATION.ADD_REQUIREMENT}
              variant="contained"
              onClick={() => handleAddRequirementSubmitClick()}
              startIcon={<AddIcon />}
              btnCss={
                !checkAccess('create')
                  ? 'add-staff-augmentation-btn-disabled'
                  : 'add-staff-augmentation-btn'
              }
            />
          </div>
        </div>
        <div className="button">
          <AddRequirementDialog
            staffData={editStaffData}
            modalOpen={addRequirementOpen}
            isEdit={isEdit}
            isCopy={isCopy}
            setIsEdit={setIsEdit}
            statusOptions={statusOptions}
            handleClose={handleAddRequirementClose}
            setRows={setRows}
            setListStaffAugData={setListStaffAugData}
            setIsCopy={setIsCopy}
          />
        </div>
        <div className="staff-augmentation-data-grid-container">
          {isLoading ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '50px',
                minHeight: '300px',
              }}
            >
              <img
                src={PuzzleLoader}
                alt="Loading..."
                className="loader-gif"
                style={{ width: '100px', height: 'auto' }}
              />
            </div>
          ) : (
            <DataGridComponent
              dataRows={listStaffAugData}
              dataColumns={fixedColumns}
              sortFilterColumns={sortFilterColumns}
              pageSize={10}
              isEdit={isEdit}
              isFilteredRows={listStaffAugData}
              onPageChange={(params) => setCurrentPage(params.page)}
              page={currentPage}
              isDealTransition
            />
          )}
        </div>
      </div>
      <DeleteStaffAugmentationDialog
        isOpen={deleteStaffAugmentationDialog}
        handleCloseAction={() => {
          setDeleteStaffAugmentationDialog(false);
        }}
        handleDeleteAction={handleDeleteStaffAugmentation}
      />
      <JobDescriptionView
        modalOpen={jobDescView}
        fileUrl={jobDescFileUrl}
        handleClose={handleCloseJobDescView}
      />
      <SimpleSnackbar
        open={openSnackbar}
        message={snackbarMessage}
        severity={severity}
      />
    </div>
  );
};

export default StaffAugmentationRequirement;
